export const answer = {
  YES: 'Oui',
  NO: 'Non',
  IDK: 'Je ne sais pas',
  NEW: 'Neuf',
  USED: 'Occasion',
  NOT_INTERESTED: 'Je ne suis pas intéressé',
  B2C: 'Un Particulier',
  B2B: 'Un Professionnel',
}

export const questions = [
  {
    title: "Vous êtes :",
    state: null,
    src: '/audi-decision/img/audi-decision-step-1.jpg',
    answers: [
      answer.B2C,
      answer.B2B,
    ],
  },
  {
    title: "Vous aimeriez conduire un modèle récent et profiter des dernières innovations",
    state: null,
    src: '/audi-decision/img/audi-decision-step-2.jpg',
    answers: [
      answer.YES,
      answer.NO,
      answer.IDK,
    ]
  },
  {
    title: "Vous aimeriez être certain de la revente de votre véhicule sans perte de valeur financière",
    state: null,
    src: '/audi-decision/img/audi-decision-step-3.jpg',
    answers: [
      answer.YES,
      answer.NO,
      answer.IDK,
    ]
  },
  {
    title: "Vous êtes à la recherche d'un financement pour un véhicule",
    state: null,
    src: '/audi-decision/img/audi-decision-step-4.jpg',
    answers: [
      answer.NEW,
      answer.USED,
      answer.IDK,
    ]
  },
  {
    title: "Vous souhaitez passer à l'électrique et financer un véhicule",
    state: null,
    src: '/audi-decision/img/audi-decision-step-5.jpg',
    answers: [
      answer.NEW,
      answer.USED,
      answer.NOT_INTERESTED,
    ]
  }
]

export const solution = {
  AUDI_LOAN: {
    title: "Audi leasing Concept 100% électrique",
    details: "Les offres Audi leasing Concept dédiées aux modèles électriques Audi e-tron vous permettent de découvrir le plaisir d’un véhicule neuf sans vous soucier de la revente. Choisissez en fonction de vos besoins l’un des packs d’assurances et de services S, M ou L et profitez de votre mobilité en toute sérénité.",
    src: '/audi-decision/img/audi-decision-solution-5.jpg',
    links: [
      {
        text: 'Prendre rendez-vous avec un conseiller',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/nous-contacter.html',
      },
      {
        text: 'Découvrir les offres Audi leasing Concept',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/vehicules-electriques.html',
      }
    ]
  },
  LEASING: {
    title: "Crédit Bail",
    details: "Le Crédit Bail vous permet de profiter de la location et de la possibilité de rachat de votre véhicule à la fin du contrat. La valeur de rachat de votre véhicule est connue dès le début de votre contrat et la TVA est lissée sur vos différentes mensualités pour vous offrir une fiscalité et une réduction de charges avantageuses.",
    src: '/audi-decision/img/audi-decision-solution-2.jpg',
    links: [
      {
        text: 'Prendre rendez-vous avec un conseiller',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/nous-contacter.html',
      },
      {
        text: 'Découvrir toutes nos solutions de financement',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/professionnels.html',
      }
    ]
  },
  CREDIT: {
    title: "Crédit Classique",
    details: "Le crédit classique vous permet de financer votre Audi neuve ou d’occasion avec un crédit adapté à votre projet et vos besoins. Vous profitez de mensualités fixes et constantes et pouvez associer des services, assurances et garanties complémentaires pour vous déplacer en toute sérénité.",
    src: '/audi-decision/img/audi-decision-solution-1.jpg',
    links: [
      {
        text: 'Prendre rendez-vous avec un conseiller',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/nous-contacter.html',
      },
      {
        text: 'Découvrir toutes nos solutions de financement',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/particuliers.html',
      }
    ]
  },
  LOA: {
    title: "Location avec Option d'Achat (LOA)",
    details: "La Location avec Option d’Achat Abrégio Style, vous offre la liberté de changer régulièrement de véhicule tout en maîtrisant votre budget. Vous ne payez que l’usage réel de votre Audi et vous pourrez tous les deux, trois, ou quatre ans, choisir un autre modèle Audi neuf.",
    src: '/audi-decision/img/audi-decision-solution-4.jpg',
    links: [
      {
        text: 'Prendre rendez-vous avec un conseiller',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/nous-contacter.html',
      },
      {
        text: 'Découvrir toutes nos solutions de financement',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/particuliers.html',
      }
    ]
  },
  LLD: {
    title: "Location Longue Durée (LLD)",
    details: "La Location Longue Durée vous permet de louer votre Audi neuve sous forme de loyers mensuels pour une durée de deux, trois ou quatre ans. Vous bénéficiez de loyers fixes ajustés à l’usage réel de votre véhicule et profitez de mensualités inférieures à celui d’un crédit classique, sans vous soucier de la revente de votre Audi.",
    src: '/audi-decision/img/audi-decision-solution-3.png',
    links: [
      {
        text: 'Prendre rendez-vous avec un conseiller',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/nous-contacter.html',
      },
      {
        text: 'Découvrir toutes nos solutions de financement',
        src: 'https://www.audi.fr/fr/web/fr/financer-mon-audi/professionnels.html',
      }
    ]
  }
}

export const decisionTree = {
  [answer.B2C]: {
    [answer.YES]: {
      [answer.YES]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
      },
      [answer.NO]:  {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
      },
      [answer.IDK]:  {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
      },
    },
    [answer.NO]: {
      [answer.YES]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
      },
      [answer.NO]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.CREDIT,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.CREDIT,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.CREDIT,
        },
      },
      [answer.IDK]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
      },
    },
    [answer.IDK]: {
      [answer.YES]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
      },
      [answer.NO]:  {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
      },
      [answer.IDK]:  {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LOA,
          [answer.NOT_INTERESTED]: solution.LOA,
        },
      },
    },
  },
  [answer.B2B]: {
    [answer.YES]: {
      [answer.YES]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
      },
      [answer.NO]:  {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
      },
      [answer.IDK]:  {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
      },
    },
    [answer.NO]: {
      [answer.YES]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
      },
      [answer.NO]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
      },
      [answer.IDK]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
      },
    },
    [answer.IDK]: {
      [answer.YES]: {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
      },
      [answer.NO]:  {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
      },
      [answer.IDK]:  {
        [answer.NEW]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
        [answer.USED]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LEASING,
        },
        [answer.IDK]: {
          [answer.NEW]: solution.AUDI_LOAN,
          [answer.USED]: solution.LEASING,
          [answer.NOT_INTERESTED]: solution.LLD,
        },
      },
    },
  }
}